import React, {useEffect, useRef, useState} from "react";
import Select from "react-dropdown-select";
import Icon from "../atoms/Icon";

const PaginationSelectBox = ({
                                 title,
                                 onChange,
                                 options,
                                 selected,
                                 label
                             }) => {

    const selectValue = [];
    options.forEach(option => {
        if (option.value === selected) {
            selectValue.push(option)
        }
    })
    const [dropdownIsOpen, setDropdownIsOpen] = useState()
    const isMounted = useRef(true);
    const changeDropDownState = (dropDown) => {
        setDropdownIsOpen(dropDown);

    }


    return (
        <div
            className={`flex h-[44px] bg-gray-side items-center  text-white
                rounded-md border-2  border-grayT/50`}>
            <div className={'w-full'}>
                <Select

                    className={"black-unselected-text"}
                    onChange={(value) => {
                        console.log("VALUEEEEEEEEEEEEE : ", value[0]);
                        onChange(value[0]);
                    }}
                    options={options}
                    direction="rtl"
                    placeholder={title}
                    dropdownPosition={"top"}
                    searchable={false}

                    color={"#5868e0"}
                    style={{
                        color: "#374170",

                        width: "100%",
                        border: "none",
                        fontSize: "13px",
                        padding: "10px 15px",
                        alignItems: "center",
                    }}

                    values={selectValue}

                    dropdownHandleRenderer={({state}) => {
                        return (
                            <span className="arrow_icon">
                                <Icon className=" w-3 h-3 inline-block"
                                      iconName={`arrow-down`}/>
                                </span>

                        )
                    }}

                />
            </div>

        </div>

    );
};

export default PaginationSelectBox;

